import { createApp } from 'vue'
import './styles/variables.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@element-plus/theme-chalk/src/index.scss'
import '@element-plus/theme-chalk/src/dark/css-vars.scss'
import App from './App.vue'
import router from './router'
import { setupStore } from './store'
import { useUserStoreWithOut } from './store/modules/user'
import { TOKEN_KEY, USER_INFO_KEY } from './constants'
import './styles/landing.css'
import './styles/layout.css'
import './styles/workbench-theme.css'

const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
app.use(router)
setupStore(app)

// 同步 token 到 sessionStorage（供 Axios 拦截器读取）
const userStore = useUserStoreWithOut()
if (userStore.getToken) {
  sessionStorage.setItem(TOKEN_KEY, userStore.getToken)
  const userInfo = userStore.getUserInfo
  if (userInfo) {
    sessionStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
  }
  // 应用启动时拉取最新用户信息，避免 localStorage 数据过时
  userStore.fetchProfile()
}

app.mount('#app')
